<template>
  <div class="special-offers-skeleton">
    <div
      class="special-offers-skeleton__card"
      v-for="n in count"
      :key="`offer-skeleton-${n}`"
    >
      <div class="special-offers-skeleton__image"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget-special-offers-skeleton',
  props: {
    count: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style scoped>
.special-offers-skeleton {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 16px;
}

.special-offers-skeleton__card {
  width: 100%;
  height: 200px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(43, 89, 120, 0.12);
  overflow: hidden;
  position: relative;
}

.special-offers-skeleton__image {
  width: 100%;
  height: 100%;
  background: #eef3f7;
  position: relative;
}

.special-offers-skeleton__image::after,
.special-offers-skeleton__card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.special-offers-skeleton__card::after {
  mix-blend-mode: soft-light;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
